/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map, List } from 'immutable';
import { unflatten } from 'flat';

import Loading from 'src/components/Loading/Loading';
import { Popup } from 'src/components/Popup/Popup';
import { CreateEventForm } from 'src/components/CreateEventForm/CreateEventForm';

class CreateEventModal extends React.Component {
    static propTypes = {
        id: PropTypes.number,
        state: PropTypes.string,
        sports: ImmutablePropTypes.map,
        competitions: ImmutablePropTypes.map,
        competitionsCollection: ImmutablePropTypes.map,
        participants: ImmutablePropTypes.list,
        active: PropTypes.bool,
        onClose: PropTypes.func,
        onFinish: PropTypes.func,

        onCreateRequest: PropTypes.func.isRequired,
        onLoadCompetitionsRequest: PropTypes.func.isRequired,
        onLoadSportsRequest: PropTypes.func.isRequired,
        // onLoadParticipantsRequest: PropTypes.func.isRequired
    };

    static defaultProps = {
        sports: Map(),
        competitions: Map(),
        participants: List(),
        active: false
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            sport: null
        };
    }

    componentDidMount() {
        this.props.onLoadSportsRequest();
    }

    UNSAFE_componentWillReceiveProps(props) {
        const { onFinish } = this.props;
        if (props.state !== this.props.state && props.state === 'FINISHED' && onFinish) {
            onFinish(props.id);
        }
    }

    onCreate(data) {
        console.log('data ', data);
        this.props.onCreateRequest(unflatten(data));
    }

    onStepFinish(step, nextStep, data) {
    //     if (step === 'sport') {
    //         this.props.onLoadParticipantsRequest(data.sport);
    //     }
    }

    onChange(field, value) {
        if (field === 'sport') {
            this.setState({
                sport: value
            });
        }
    }

    render() {
        const { competitions, competitionsCollection, onLoadCompetitionsRequest, sports, participants, active, onClose } = this.props;
        const { sport } = this.state;

        const listCompetitions = competitionsCollection.getIn( [ sport, 'items' ], List() )
            .reduce( ( acc, compId ) => acc.set( compId, competitions.get( compId ) ), Map() );

        let form;
        if (active) {
            form = (
                <CreateEventForm
                    sports={ sports }
                    competitions={ listCompetitions }
                    competitionsCollection={ competitionsCollection }
                    participants={ participants }
                    onSubmit={ this.onCreate.bind(this)}
                    onChange={ this.onChange.bind(this)}
                    onLoadCompetitionsRequest={ onLoadCompetitionsRequest }
                    onStepFinish={ this.onStepFinish.bind(this)}
                />
            );
        }

        return (
            <Popup
                title='Create event'
                className='create-event-modal'
                priority={ 1000 }
                active={ active }
                onClose={ onClose }
            >
                { form }
            </Popup>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default CreateEventModal;
